var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "play_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52 2.122a1 1 0 011.02.037l14 9a1 1 0 010 1.682l-14 9A1 1 0 015 21V3a1 1 0 01.52-.878zM7 4.832v14.336L18.15 12 7 4.832z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuNTIwODEgMi4xMjIyOUM1Ljg0MTg5IDEuOTQ3IDYuMjMzMDUgMS45NjEwMSA2LjU0MDc2IDIuMTU4ODJMMjAuNTQwOCAxMS4xNTg4QzIwLjgyNyAxMS4zNDI4IDIxIDExLjY1OTcgMjEgMTJDMjEgMTIuMzQwMyAyMC44MjcgMTIuNjU3MiAyMC41NDA4IDEyLjg0MTJMNi41NDA3NiAyMS44NDEyQzYuMjMzMDUgMjIuMDM5IDUuODQxODkgMjIuMDUzIDUuNTIwODEgMjEuODc3N0M1LjE5OTc0IDIxLjcwMjQgNSAyMS4zNjU4IDUgMjFWM0M1IDIuNjM0MTkgNS4xOTk3NCAyLjI5NzU4IDUuNTIwODEgMi4xMjIyOVpNNyA0LjgzMTY3VjE5LjE2ODNMMTguMTUwNyAxMkw3IDQuODMxNjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgPlay as ReactComponent };